import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import '../../../styles/FiestaTheme.css';

const FiestaTheme = ({ isPreview = true }) => {
  const { celebrantName } = useParams();
  const [isRevealed, setIsRevealed] = useState(false);
  const [activeSection, setActiveSection] = useState('home');
  const [rsvpData, setRsvpData] = useState({
    name: '',
    attending: '',
    guests: '1',
    message: ''
  });

  // Parse celebrant name
  const formatName = (name) => {
    if (!name) return 'Celebrant';
    return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
  };

  const invitationData = {
    celebrantName: formatName(celebrantName),
    age: '7',
    partyDate: 'August 15, 2026',
    partyDay: 'Saturday',
    partyTime: '3:00 PM',
    venue: 'Barangay Hall',
    venueAddress: '123 Fiesta Street, Manila',
    message: 'Join us for a colorful Filipino fiesta celebration!',
    theme: 'Fiesta Filipina',
    dressCode: 'Filipiniana / Barong'
  };

  useEffect(() => {
    const timer = setTimeout(() => setIsRevealed(true), 500);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="fiesta-theme">
      {/* Fiesta Decorations */}
      <div className="fiesta-decorations">
        <div className="banderitas">
          <div className="banderita b1"></div>
          <div className="banderita b2"></div>
          <div className="banderita b3"></div>
          <div className="banderita b4"></div>
          <div className="banderita b5"></div>
          <div className="banderita b6"></div>
          <div className="banderita b7"></div>
          <div className="banderita b8"></div>
        </div>
        <div className="parol parol-1">✦</div>
        <div className="parol parol-2">✦</div>
      </div>

      {/* Main Content */}
      <div className={`fiesta-container ${isRevealed ? 'revealed' : ''}`}>
        {/* Navigation */}
        <nav className="fiesta-nav">
          <button 
            className={activeSection === 'home' ? 'active' : ''} 
            onClick={() => setActiveSection('home')}
          >
            🏠 Home
          </button>
          <button 
            className={activeSection === 'details' ? 'active' : ''} 
            onClick={() => setActiveSection('details')}
          >
            📍 Details
          </button>
          <button 
            className={activeSection === 'rsvp' ? 'active' : ''} 
            onClick={() => setActiveSection('rsvp')}
          >
            ✉️ RSVP
          </button>
        </nav>

        {/* Home Section */}
        {activeSection === 'home' && (
          <section className="fiesta-section home-section">
            <div className="fiesta-frame">
              <div className="frame-pattern top"></div>
              
              <div className="home-content">
                <div className="fiesta-badge">
                  <span className="badge-text">🎉 FIESTA 🎉</span>
                </div>

                <p className="invitation-prefix">Tara na sa</p>
                
                <div className="celebrant-info">
                  <span className="celebrant-name">{invitationData.celebrantName}'s</span>
                  <span className="birthday-text">Birthday Fiesta!</span>
                </div>

                <div className="age-parol">
                  <div className="parol-design">
                    <span className="age-number">{invitationData.age}</span>
                  </div>
                  <span className="years-old">years old</span>
                </div>

                <div className="fiesta-divider">
                  <span className="divider-icon">🌺</span>
                </div>

                <p className="invitation-message">{invitationData.message}</p>

                <div className="event-info-home">
                  <div className="info-item">
                    <span className="info-icon">📅</span>
                    <span className="info-text">{invitationData.partyDate}</span>
                  </div>
                  <div className="info-item">
                    <span className="info-icon">⏰</span>
                    <span className="info-text">{invitationData.partyTime}</span>
                  </div>
                </div>

                <button 
                  className="fiesta-btn"
                  onClick={() => setActiveSection('details')}
                >
                  Tingnan ang Details! 🎊
                </button>
              </div>

              <div className="frame-pattern bottom"></div>
            </div>
          </section>
        )}

        {/* Details Section */}
        {activeSection === 'details' && (
          <section className="fiesta-section details-section">
            <h2 className="section-title">
              <span className="title-icon">🎪</span>
              Event Details
              <span className="title-icon">🎪</span>
            </h2>

            <div className="details-cards">
              <div className="detail-card venue-card">
                <div className="card-icon">📍</div>
                <h3>Saan?</h3>
                <p className="venue-name">{invitationData.venue}</p>
                <p className="venue-address">{invitationData.venueAddress}</p>
              </div>

              <div className="detail-card schedule-card">
                <div className="card-icon">📆</div>
                <h3>Kailan?</h3>
                <p className="schedule-date">{invitationData.partyDay}</p>
                <p className="schedule-full">{invitationData.partyDate}</p>
                <p className="schedule-time">{invitationData.partyTime}</p>
              </div>

              <div className="detail-card theme-card">
                <div className="card-icon">🎨</div>
                <h3>Theme</h3>
                <p className="theme-name">{invitationData.theme}</p>
                <p className="dress-code">{invitationData.dressCode}</p>
              </div>

              <div className="detail-card food-card">
                <div className="card-icon">🍖</div>
                <h3>Pagkain</h3>
                <p className="food-text">Lechon, Pancit, Lumpia</p>
                <p className="food-note">at marami pang iba!</p>
              </div>
            </div>

            <div className="activities-section">
              <h3>🎮 Mga Laro at Activities</h3>
              <div className="activities-list">
                <span className="activity">🪑 Trip to Jerusalem</span>
                <span className="activity">🎵 Pabitin</span>
                <span className="activity">🎤 Videoke</span>
                <span className="activity">💃 Sayawan</span>
              </div>
            </div>

            <button 
              className="fiesta-btn"
              onClick={() => setActiveSection('rsvp')}
            >
              Mag-RSVP Na! 📝
            </button>
          </section>
        )}

        {/* RSVP Section */}
        {activeSection === 'rsvp' && (
          <section className="fiesta-section rsvp-section">
            <h2 className="section-title">
              <span className="title-icon">💌</span>
              RSVP
              <span className="title-icon">💌</span>
            </h2>

            <form className="fiesta-rsvp-form" onSubmit={(e) => e.preventDefault()}>
              <p className="rsvp-intro">Excited na kami makita ka!</p>
              <p className="rsvp-deadline">Paki-confirm bago mag August 10, 2026</p>

              <div className="form-group">
                <label>Pangalan Mo</label>
                <input
                  type="text"
                  name="name"
                  value={rsvpData.name}
                  placeholder="I-type ang pangalan mo"
                  disabled={isPreview}
                />
              </div>

              <div className="form-group">
                <label>Pupunta ka ba?</label>
                <div className="attendance-options">
                  <label className={`attendance-option ${isPreview ? 'disabled' : ''}`}>
                    <input
                      type="radio"
                      name="attending"
                      value="yes"
                      disabled={isPreview}
                    />
                    <span className="option-emoji">🎉</span>
                    <span className="option-text">Oo naman!</span>
                  </label>
                  <label className={`attendance-option ${isPreview ? 'disabled' : ''}`}>
                    <input
                      type="radio"
                      name="attending"
                      value="no"
                      disabled={isPreview}
                    />
                    <span className="option-emoji">😢</span>
                    <span className="option-text">Hindi ko kaya</span>
                  </label>
                </div>
              </div>

              <div className="form-group">
                <label>Ilan kayo?</label>
                <select
                  name="guests"
                  value={rsvpData.guests}
                  disabled={isPreview}
                >
                  <option value="1">1 - Ako lang</option>
                  <option value="2">2 - Dalawa kami</option>
                  <option value="3">3 - Tatlo kami</option>
                  <option value="4">4 - Apat kami</option>
                  <option value="5">5+ - Madami kami!</option>
                </select>
              </div>

              <div className="form-group">
                <label>Message para kay {invitationData.celebrantName}</label>
                <textarea
                  name="message"
                  value={rsvpData.message}
                  placeholder="I-share ang birthday greeting mo..."
                  rows="3"
                  disabled={isPreview}
                />
              </div>

              <button type="submit" className="fiesta-btn submit-btn" disabled={isPreview}>
                I-Send ang RSVP! 🎊
              </button>
            </form>
          </section>
        )}

        {/* Watermark */}
        <div className="fiesta-watermark">
          <a href="/invitations" className="back-to-templates-btn">Back to Designs</a>
          <p>Created with 💖 by <a href="https://logicatechnology.com" target="_blank" rel="noopener noreferrer">Logica Technology</a></p>
        </div>
      </div>
    </div>
  );
};

export default FiestaTheme;
